import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes, paddingAttributes, sizeAttributes, textAlignmentAttributes, displayAttributes, colorAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
export var BoxRoot = styled.div.withConfig(getPropsBlocker())(_templateObject(), marginAttributes, paddingAttributes, sizeAttributes, textAlignmentAttributes, displayAttributes, colorAttributes);